/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Faq_4_QuestionInputs */

const en_svc_rag_faq_4_question = /** @type {(inputs: Svc_Rag_Faq_4_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can the same knowledge base serve customers and staff?`)
};

const lv_svc_rag_faq_4_question = /** @type {(inputs: Svc_Rag_Faq_4_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai viena zināšanu bāze var kalpot gan klientiem, gan darbiniekiem?`)
};

/**
* | output |
* | --- |
* | "Can the same knowledge base serve customers and staff?" |
*
* @param {Svc_Rag_Faq_4_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_faq_4_question = /** @type {((inputs?: Svc_Rag_Faq_4_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Faq_4_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_faq_4_question(inputs)
	return en_svc_rag_faq_4_question(inputs)
});